import { render, staticRenderFns } from "./WantedLoop.vue?vue&type=template&id=718b1aed&scoped=true&"
import script from "./WantedLoop.vue?vue&type=script&lang=js&"
export * from "./WantedLoop.vue?vue&type=script&lang=js&"
import style0 from "./WantedLoop.vue?vue&type=style&index=0&id=718b1aed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718b1aed",
  null
  
)

export default component.exports